import { CustomCalendarType } from "@ac-expo/api-types";
import { PlanningEventCard } from "./PlanningCards";
import { FiltersBars } from "./filter-bars";
import {
  getBackgroundContainerStyle,
  getBackgroundOverlayStyle,
  isPlanningGroup,
  PlanningEvent,
} from "./utils";
import dayjs from "dayjs";

interface VerticalByPlaceCalendarProps {
  allDaysWithActivities: dayjs.Dayjs[];
  filteredSlots: PlanningEvent[];
  groupedPlaces: Record<string, PlanningEvent[]>;
  setPlaceFilter: (place: string | undefined) => void;
  onOpenActivitiesDetails?: (events: PlanningEvent[]) => void;
  isRegisterEnabled?: boolean;
  customCalendar?: CustomCalendarType;
  backgroundStyleOptions: {
    backgroundPictureUrl?: string;
    backgroundColor?: string;
    opacity?: number;
  };
}

export const VerticalByPlaceCalendar = ({
  allDaysWithActivities,
  filteredSlots,
  groupedPlaces,
  setPlaceFilter,
  onOpenActivitiesDetails,
  isRegisterEnabled,
  customCalendar,
  backgroundStyleOptions,
}: VerticalByPlaceCalendarProps) => {
  const firstDay = allDaysWithActivities[0]?.format("DD/MM/YYYY");
  const lastDay =
    allDaysWithActivities[allDaysWithActivities.length - 1]?.format(
      "DD/MM/YYYY"
    );

  // Sort places alphabetically with empty places at the end
  const sortedPlaces = Object.entries(groupedPlaces).sort(([a], [b]) => {
    if (a === "") return 1;
    if (b === "") return -1;
    return a.localeCompare(b, "fr");
  });

  return (
    <div>
      <div className="flex items-center justify-between px-4 py-4 border-b border-gray-200 mb-2">
        <span className="text-base font-bold text-gray-700">
          Du {firstDay} au {lastDay}
        </span>
        <FiltersBars
          slots={filteredSlots}
          onOpenActivitiesDetails={onOpenActivitiesDetails}
          placeNames={Object.keys(groupedPlaces).filter(
            (place) => place.length > 0
          )}
          setPlaceFilter={setPlaceFilter}
        />
      </div>
      <div className="flex flex-col gap-6">
        {sortedPlaces.map(([group, slots]) => (
          <div key={group || "no-place"} className="flex flex-col gap-2">
            <p className="whitespace-nowrap px-4 text-xl font-extrabold text-black">
              {group || "Sans lieu affecté"}
            </p>
            <div
              className="relative"
              style={getBackgroundContainerStyle(backgroundStyleOptions)}
            >
              <div
                className="absolute inset-0 z-10 overflow-hidden"
                style={getBackgroundOverlayStyle(backgroundStyleOptions)}
              />
              <div className="relative z-20 grid grid-cols-2 gap-y-3 gap-x-8 p-4 border border-gray-200">
                {slots.map((slot, slotIndex) => (
                  <PlanningEventCard
                    key={slotIndex}
                    event={slot}
                    openDetails={onOpenActivitiesDetails}
                    withRegister={
                      isRegisterEnabled &&
                      !isPlanningGroup(slot) &&
                      slot.isRegistrationRequired
                    }
                    customCalendar={customCalendar}
                    isMobile={false}
                  />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
